export const featureFlags = {
    budget: false,

    // Módulo de Atendimentos (chamado TAS)
    tasOccurrenceLogsTab: false,
    tasOccurrenceVehicleContainer: false
}
